/**
 * h5和app交互 bridge.js
 */
import '@/core/prototype';
import WdzUploader from '@/core/Uploader';
import Ovopark from './src/Ovopark';
import { addStartLoading, hideStartLoading } from './src/loading';
import { addNavBar, getNavBarDom } from './src/nav-bar';
import WdzRequest from '@/core/request';
import { isInWhiteListHost } from '@/core/utils';
import { Language } from '@/core/language';

// 资源加载的域名，用来动态加载sdk和语言包
let sourceOrigin = '';
let fallbackLanguage: Language | undefined;

(() => {
  const scripts = document.getElementsByTagName('script');
  // 获取当前引入js的src
  const currentSrc = scripts?.length && scripts[scripts.length - 1].src;
  if (!currentSrc || !currentSrc.includes('bridge')) {
    return;
  }

  const url = new URL(currentSrc);
  if (process.env.NODE_ENV === 'development') {
    sourceOrigin = 'https://test.wistore.net';
  } else {
    sourceOrigin = url.origin;
  }

  // 引入地址参数指定语言，用于fallback
  fallbackLanguage = url.searchParams.get('lang') as Language;

  // 监听DOM加载完成，才能插入DOM
  document.addEventListener('DOMContentLoaded', () => {
    if (url.searchParams.get('loading')) {
      // 增加loading
      addStartLoading();
    }
    if (ovopark.isNavbar) {
      // 增加导航栏
      addNavBar();
    }
  });
})();

// 阿里云arms接入，只有正式服才接入
if (process.env.NODE_ENV !== 'development' && process.env.MODE !== 'testing') {
  // @ts-ignore
  !(function (win, doc, src, name) {
    // 只有白名单域名才接入arms
    if (!isInWhiteListHost()) {
      return;
    }

    win[name] || (win[name] = {});
    win[name].config = {
      pid: 'ix047@57f616f8dbc029d',
      appType: 'web',
      imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
      sendResource: true,
      enableLinkTrace: true,
      behavior: true,
    };
    const script = doc.createElement('script');
    script.setAttribute('crossorigin', '');
    script.src = src;
    doc.head.appendChild(script);
  })(window, document, 'https://retcode.alicdn.com/retcode/bl.js', '__bl');
}

window.WdzUploader = WdzUploader;
window.WdzRequest = WdzRequest;

const ovopark = new Ovopark({
  sourceOrigin,
  fallbackLanguage,
});

// @ts-ignore
ovopark.hideStartLoading = hideStartLoading;
// @ts-ignore
ovopark.getNavBarDom = getNavBarDom;

export default ovopark;
